import { PhotoFade } from '@/ui/core/block'
import { Image } from 'expo-image'
import { StyleSheet, View } from 'react-native'
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated'
import Images from '#/assets/images/image-map'

/**
 * The photograph behind the welcome: a laugh, close enough to see the earrings. It fills the
 * screen edge to edge under the header and the button; the fade at the bottom is what lets white
 * type sit on it. It dissolves away when the form takes over the screen on the pink.
 */
export const LoginBackdrop = () => (
	<Animated.View
		style={StyleSheet.absoluteFill}
		pointerEvents="none"
		entering={FadeIn.duration(260)}
		exiting={FadeOut.duration(260)}
	>
		<View style={StyleSheet.absoluteFill} className="bg-blush" />
		<Image
			source={Images.Laugh}
			style={StyleSheet.absoluteFill}
			contentFit="cover"
			contentPosition={{ left: '42%', top: '40%' }}
			transition={300}
		/>
		<PhotoFade from={0.1} to={0.78} start={0.2} />
	</Animated.View>
)
